<h1 mat-dialog-title>
    Mobile Operators
    <br>
    {{ mopOperatorsMessage.aliveMonitors }}
    /
    {{ mopOperatorsMessage.requiredMonitors }}
</h1>
<div mat-dialog-content class="line">
    <ul id="users-monitoring-list">
        <li *ngFor="let user of mopOperatorsMessage.usersMonitoring">
            <mat-icon [ngClass]="{'hide-current-user': !user.currentUser}">person</mat-icon>
            <span>{{user.userName}}</span>
        </li>
    </ul>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Back</button>
</div>
